import { render, staticRenderFns } from "./PromoCodesEditorPage.vue?vue&type=template&id=7d23a10a&scoped=true&"
import script from "./PromoCodesEditorPage.vue?vue&type=script&lang=js&"
export * from "./PromoCodesEditorPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d23a10a",
  null
  
)

export default component.exports